import { Instance } from 'mobx-state-tree';
import { PharmacyStatusStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';

import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { PharmacyStatus } from '../../../store/models/PharmacyStatus';

interface PharmacyStatusFormFieldProps extends WithTranslateProps {
  PharmacyStatusStore?: Instance<typeof PharmacyStatusStore>;
  onPharmacyStatusIdChanged?: (pharmacyStatusId: number | undefined) => void;
  pharmacyStatusId?: number | undefined;
}

@inject('PharmacyStatusStore')
@observer
class PharmacyStatusFormField extends React.Component<PharmacyStatusFormFieldProps> {
  renderPharmacyStatusMenuItem(
    item: Instance<typeof PharmacyStatus>,
    { handleClick, index, modifiers }: IItemRendererProps,
  ) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`status-${index}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.code + ' - ' + item.name}
        />
      );
    } else {
      return null;
    }
  }

  render() {
    const { PharmacyStatusStore, ...otherProps } = this.props;

    return (
      <>
        <SelectInputFormField
          label={TLCode.PHARMACY_Status}
          name="statusId"
          inline={true}
          items={toJS(PharmacyStatusStore!.dataList)}
          itemValueGetter={(item: Instance<typeof PharmacyStatus>) => item.pharmacyStatusId}
          valueItemGetter={(value) => PharmacyStatusStore!.dataList.find((ps) => ps.pharmacyStatusId === value)!}
          inputValueRenderer={(item) => (item != null ? item.code + ' - ' + item.name! : '')}
          itemRenderer={this.renderPharmacyStatusMenuItem}
          identifier={'statusId'}
          elementLabel={'name'}
          labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_PHARMACY_STATUS)}
          helperText={this.props.translate(TLCode.CHOOSE_A_PHARMACY_STATUS)}
          placeholderSelection={TLCode.CHOOSE_A_PHARMACY_STATUS}
          afterItemSelected={otherProps.onPharmacyStatusIdChanged}
          {...otherProps}
        />
      </>
    );
  }
}

export default withTranslate(PharmacyStatusFormField);
